import React, { Component } from 'react'
import { Subscribe } from "unstated";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import { myUtilities } from "../../Utils";
import { connect } from "react-redux";


class RetryContainer extends Component {
  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
      {(data) => (
        <Subscribe to={[InvoiceDataContainer]}>
          {(invData) => (
            <div className="master-retry">
              {!this.props.retryReceipt.receiptGenerated &&
                this.props.retryReceipt.receiptFailCount < 3 && (
                  <div className={this.props.retryReceipt.receiptCallHappening
                    ? "retry-container retry-container-loading"
                    : "retry-container"}> <span>
                    {
                     
                    this.props.retryReceipt.receiptCallHappening ?  myUtilities.accountSpecificLanguage(
                        "payment.success.receipt.generating",
                        "Generating receipt..."
                      ) : " "}</span>
                    <button
                      className={
                         this.props.retryReceipt.receiptCallHappening
                          ? "action-btn loading"
                          : "action-btn"
                      }
                      id="login-btn"
                      onClick={() => {
                        if(this.props.retryReceipt.receiptCallHappening || this.props.retryReceipt.receiptGenerated) return;
                        window.triggerReceiptCall(data, invData);
                      }}
                    >
                      {myUtilities.accountSpecificLanguage(
                        "payment.success.receipt.retry",
                        "Retry receipt generation"
                      )}
                    </button>
                  </div>
                )}
              {!this.props.retryReceipt.receiptGenerated &&
                !this.props.retryReceipt.receiptCallHappening &&
                this.props.retryReceipt.receiptFailCount >= 3 && (
                  <div>
                    {myUtilities.accountSpecificLanguage(
                      "payment.success.receipt.attemptsExhausted1",
                      "Maximum attempts for payment receipt generation reached."
                    )}
                    <br/>
                    {myUtilities.accountSpecificLanguage(
                      "payment.success.receipt.attemptsExhausted2",
                      "Please get in touch with your administrator with Transaction ID: " +
                        data.state.transactionID
                    )}
                  </div>
                )}
            </div>
          )}
        </Subscribe>
      )}
    </Subscribe>
    )
  }
}
const mapStateToProps = (state) => ({
  retryReceipt: state.retryReceipt,
});


export default connect(mapStateToProps, null)(RetryContainer);